import axios from "@/api/interceptor_meta";

/**
 * 财务管理
 * @param params
 * @returns
 */

// 获取余额
export function getFundsBalance(params: any) {
  return axios.get("/agent/funds/balance", { params });
}

// 充值
export function postMetaFundsRecharge(data: any) {
  return axios.post("/agent/funds/recharge", data);
}

// 充值记录
export function getFundsRechargeRecord(params: any) {
  return axios.get("/agent/funds/recharge-record", { params });
}

// 充值记录统计
export function getFundsRechargeStatistics(params: any) {
  return axios.get("/agent/funds/recharge-statistics", { params });
}

// 退款
export function getFundsRefundRecord(params: any) {
  return axios.get("/agent/funds/refund-record", { params });
}

// 退款记录统计
export function getFundsRefundStatistics(params: any) {
  return axios.get("/agent/funds/refund-statistics", { params });
}

// 扣费
export function getFundsDeductionRecord(params: any) {
  return axios.get("/agent/funds/deduction-record", { params });
}

// 扣费记录统计
export function getFundsDeductionStatistics(params: any) {
  return axios.get("/agent/funds/deduction-statistics", { params });
}

// 二代充值
export function getFundsAgent2RechargeRecord(params: any) {
  return axios.get("/agent/funds/agent2-recharge-record", { params });
}

// 二代充值记录统计
export function getFundsAgent2RechargeStatistics(params: any) {
  return axios.get("/agent/funds/agent2-recharge-statistics", { params });
}

// 二代退款
export function getFundsAgent2RefundRecord(params: any) {
  return axios.get("/agent/funds/agent2-refund-record", { params });
}

// 二代退款记录统计
export function getFundsAgent2RefundStatistics(params: any) {
  return axios.get("/agent/funds/agent2-refund-statistics", { params });
}

// 二代扣费记录
export function getFundsAgent2DeductionRecord(params: any) {
  return axios.get("/agent/funds/agent2-deduction-record", { params });
}

// 二代扣费记录统计
export function getFundsAgent2DeductionStatistics(params: any) {
  return axios.get("/agent/funds/agent2-deduction-statistics", { params });
}
